import React from "react";

import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

import IconAdd from "../../assents/img/add.svg";

const CustomButton = styled(Button, {
  shouldForwardProp: (propName) => propName !== "isModal",
})(({ theme, isModal }) => ({
  width: isModal ? "71px" : "100%",
  padding: isModal ? "10px 14px" : "22.5px",
  background: "#2bb656",
  borderRadius: isModal ? "5px" : "8px",
  border: "none",
  boxSizing: "border-box",
  textTransform: "none",
  fontFamily: "Proxima Nova",
  fontWeight: "bold",
  fontSize: "16px",
  lineHeight: 1.187,
  color: "#ffffff",
  cursor: "pointer",
  ...(isModal
    ? {
        marginTop: "10px",
      }
    : null),
  "&:hover": {
    background: "#2bb656",
  },
  [theme.breakpoints.up("sm")]: {
    width: isModal ? "75px" : "138px",
    padding: isModal ? "10px 14px" : "13.5px 27px",
  },
}));

const Add = styled("img")(({ theme }) => ({
  marginRight: "4px",
  [theme.breakpoints.up("sm")]: {
    marginRight: "auto",
  },
}));

const AddStopButton = ({ isModal, isStopInfoModal, handleClick }) => {
  return (
    <CustomButton isModal={isModal} onClick={handleClick}>
      <Add src={IconAdd} />
      Add {isModal ? "" : isStopInfoModal ? "to tour" : "stop"}
    </CustomButton>
  );
};

export default AddStopButton;
